import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_REGEX, extractFromColumn } from "../utils/extract";

export interface IParsedFile {
  fileName: string;
  headers: string[];
  rows: string[][];
}

export interface ExtractState {
  fileName: string;
  headers: string[];
  rows: string[][];
  selectedColumn: number;
  regex: string;
  savedRegexes: string[];
  extracted: string[];
}

const initialState: ExtractState = {
  fileName: "",
  headers: [],
  rows: [],
  selectedColumn: 0,
  regex: DEFAULT_REGEX,
  savedRegexes: [DEFAULT_REGEX],
  extracted: [],
};

export const extractSlice = createSlice({
  name: "extract",
  initialState,
  reducers: {
    setParsedFile: (state, action: PayloadAction<IParsedFile>) => {
      state.fileName = action.payload.fileName;
      state.headers = action.payload.headers;
      state.rows = action.payload.rows;
      state.selectedColumn = 0;
      state.extracted = [];
    },
    setSelectedColumn: (state, action: PayloadAction<number>) => {
      state.selectedColumn = action.payload;
    },
    setRegex: (state, action: PayloadAction<string>) => {
      state.regex = action.payload;
    },
    applyExtraction: (state) => {
      const results = extractFromColumn(
        state.rows,
        state.selectedColumn,
        state.regex
      );
      state.extracted = results.map((r) => r.value);

      const regex = state.regex.trim();
      if (regex && !state.savedRegexes.includes(regex)) {
        state.savedRegexes.push(regex);
      }
    },
  },
});

export const { setParsedFile, setSelectedColumn, setRegex, applyExtraction } =
  extractSlice.actions;

export default extractSlice.reducer;
